import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Institution } from './Institution';
import { InstitutionGroup } from './InstitutionGroup';

export interface TaskGroupViewRow {
  institution_id: number;
  institution_group_id: string;
  pending_task_count: number;
  active_task_count: number;
  completed_task_count: number;
  completed_percentage: string;
}

export const TaskGroupView: Entity<TaskGroupViewRow> = {
  id: 'TaskGroupView',
  title: 'Task Group',
  service: 'main',
  rowLabel: (row: TaskGroupViewRow) => row.institution_group_id,
  primaryKeyFields: ['institution_group_id'],
  source: {
    tableName: 'public.task_group_view',
  },
  defaultSort: [['institution_group_id', 'ASC']],
  security: [
    { role: 'admin', action: 'read', access: 'conditional', condition: 'institution_id = {adminInstitutionId}' },
    { role: 'staff', action: 'read', access: 'all' },
  ],
  fields: {
    institution_id: {
      seq: 5,
      type: FieldType.Reference,
      label: 'Institution',
      refEntity: Institution,
    },
    institution_group_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Institution Group',
      listColumn: true,
      refEntity: InstitutionGroup,
    },
    pending_task_count: {
      seq: 15,
      type: FieldType.Integer,
      label: 'Pending Task Count',
      listColumn: true,
      fieldGroup: 'summary',
    },
    active_task_count: {
      seq: 20,
      type: FieldType.Integer,
      label: 'Active Task Count',
      listColumn: true,
      fieldGroup: 'summary',
    },
    completed_task_count: {
      seq: 25,
      type: FieldType.Integer,
      label: 'Completed Task Count',
      listColumn: true,
      fieldGroup: 'summary',
    },
    completed_percentage: {
      seq: 30,
      type: FieldType.Text,
      label: 'Completed Percentage',
      listColumn: true,
      fieldGroup: 'summary',
      listColumnAlign: 'right',
      persistence: PersistenceType.FrontEndOnly,
      evaluateFrontEndIn: (row: TaskGroupViewRow) => {
        const denominator = row.pending_task_count + row.active_task_count + row.completed_task_count;
        return denominator === 0 ? '-' : ((row.completed_task_count / denominator) * 100).toFixed(0) + '%';
      },
    },
  },
};
